import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    // 0.27.0 (WCAG 2.1.1): a table already inside a labelled, focusable scroll region is left
    // alone, so it does not get a second, unreachable scroller. Any other wrapper that overflows
    // is made reachable from the keyboard and named after the table caption.
    if (table.closest('[role="region"][tabindex]')) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      requestAnimationFrame(() => {
        if (wrapper.scrollWidth > wrapper.clientWidth + 1) {
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-label', (table.caption && table.caption.textContent.trim()) || 'Table');
        }
      });
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
